var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6797 10.8125C14.9141 10.8125 15.1094 10.8906 15.2656 11.0469C15.4219 11.2031 15.5 11.3984 15.5 11.6328V14.5234C15.5 15.1745 15.2266 15.5 14.6797 15.5C10.7995 15.5 7.46615 14.1068 4.67969 11.3203C1.89323 8.53385 0.5 5.20052 0.5 1.32031C0.5 0.773438 0.825521 0.5 1.47656 0.5H4.36719C4.60156 0.5 4.79688 0.578125 4.95312 0.734375C5.10938 0.890625 5.1875 1.08594 5.1875 1.32031C5.1875 2.33594 5.34375 3.3125 5.65625 4.25C5.76042 4.58854 5.69531 4.875 5.46094 5.10938L3.85938 6.51562C5.05729 9.01562 6.97135 10.9036 9.60156 12.1797L10.8906 10.5391C11.0469 10.3828 11.2422 10.3047 11.4766 10.3047C11.6068 10.3047 11.6979 10.3177 11.75 10.3438C12.6875 10.6562 13.6641 10.8125 14.6797 10.8125Z",
    fill: "#1F3B98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.e4235a2190fc14128a6d92164c43d8a9.svg";
export { ForwardRef as ReactComponent };